import React, { useRef } from 'react';
import cn from 'classnames';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { DisplayType } from '@kaltura-ott/tvpil/interfaces';
import { LinkAsAsset } from '@kaltura-ott/tvpil-shared';

import { IMAGE_PARAM } from 'consts';

import { IN_APP_LINK_HOME } from '../../constans';
import resolveMenuLinks from '../../resolveMenuLinks';
import Logo from '../Logo/Logo';
import MenuItemsCombiner from '../MenuItemsCombiner/MenuItemsCombiner';

import LinkViewResolver from './components/LinkViewResolver/LinkViewResolver';

import styles from '../../Menu.module.scss';

type Props = {
  menuItem: LinkAsAsset;
  subtype?: UIDAPresentationTypeEnum;
};

function MenuItem({ menuItem: linkAsAsset, subtype }: Props) {
  const ref = useRef<HTMLLIElement | null>(null);
  const isActiveLink = useRef<string | undefined>(undefined);

  const menuItem = linkAsAsset.data.linkItem!;
  const path = resolveMenuLinks(menuItem);
  const isHomePageLink = menuItem.inAppLink?.toLowerCase() === IN_APP_LINK_HOME;
  const isItemAsHomePageLogo = menuItem.image && menuItem.displayType === DisplayType.imageOnly && isHomePageLink;

  const handleCheckIsLinkActive = () => {
    if (ref.current) {
      ref.current.setAttribute('active', `${path === isActiveLink.current}`);
    }
  };

  if (!menuItem) {
    return null;
  }

  return (
    <>
      <MenuItemsCombiner isActive={isActiveLink} callback={handleCheckIsLinkActive} />
      <li ref={ref} key={`${menuItem.name}-${menuItem.inAppLink}`}>
        {isItemAsHomePageLogo ? (
          <Logo className={cn(styles.logo)} path={path} description={menuItem.name} image={`${menuItem.image}${IMAGE_PARAM}`} />
        ) : (
          <LinkViewResolver subtype={subtype} path={path} linkAsAsset={linkAsAsset} />
        )}
      </li>
    </>
  );
}

export default React.memo(MenuItem);
